

// import "";
import icespice from '../css/img/icespice-logo.png'
import check from '../css/img/check.png'
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link, useLocation, useNavigate ,useSearchParams} from 'react-router-dom';
import { useEffect, useState } from 'react';
import { emailOTPVerification} from '../Services/Service';

function Email() {
  const nav = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
    let code = searchParams.get("code")
//   const {redirect,reredirect} = useLocation().state;
//   console.log(redirect,reredirect)
  const [user, setUser] = useState("");
  useEffect(()=>{
  //  const userId = localStorage.getItem("auth");
  //  if(userId){
    emailOTPVerification(code).then(res=>{
      setUser(res.data.data.msg)
    }).catch((err) => console.log(err.message));
  //  }

  },[])
  return (
    <div className="content-app">
                  <HelmetProvider>
        <Helmet>
          <title>Congratulations</title>
        </Helmet>
      </HelmetProvider>
      <>
  <div style={{ height: 140 }}></div>
  <div
    style={{
      maxWidth: 550,
    //   backgroundColor: "white",
      margin: "-80px auto 0 auto",
      padding: "20px 60px 80px 60px"
    }}
  >
    <div
      style={{
        fontSize: 30,
        fontWeight: 300,
        marginTop: 20,
        textAlign: "center"
      }}
    >
      {" "}

            <br/>
      Email Confirmed!
    </div>
    <br />
    {user && <p>
      Congratulations! Your email has been confirmed and your account is ready.
      Please close this page and go back to the mobile app to login.
    </p>}

    
    <div className=" box-sizing: border-box; width: 100%;">
      <div style={{ fontSize: 18, textAlign: "center" }}>
      <Link to="/auth-login">
                <img src={"/assets/images/icespice-logo.png"} alt="IceSpice Logo" className="logo" height="36"/>
            </Link>
            <br/>
        Welcome to the Icespice Network!
      </div>
    </div>
  </div>
</>

  </div>
  );
}

export default Email;
